import { MessageResponseDto } from "@api/api";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { cardCategoryFormDefault } from "@factory/form/form.default";
import {
  CardCategoryFormRule,
  CardCategoryFormSchema,
} from "@factory/form/form.rule";
import { useQyCreateCardCategory } from "@factory/query/card-category.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewCardCategory() {
  // LOCAL DECLARATION
  const { getUserRole } = useUserIdentityContext();
  const { tenant } = getUserRole();
  const navigate = useNavigate();
  const { mapCreateCardCategory } = useFormApiMapper();
  const { showError, showSuccess } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New CardCategory is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addCardCategory, isLoading: isCreating } =
    useQyCreateCardCategory(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<CardCategoryFormSchema>({
    defaultValues: cardCategoryFormDefault,
    resolver: zodResolver(CardCategoryFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: CardCategoryFormSchema) => {
    const updatedForm = {
      ...form,
      tenant,
    };
    const formData = mapCreateCardCategory(updatedForm);
    addCardCategory(formData);
  };
  const handleValidateError = (err: FieldErrors<CardCategoryFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
